import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Text } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const CustomVideoPlayer = makeShortcode("CustomVideoPlayer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`Use an action bar to render multiple icon buttons in a row. Buttons can be split into groups by adding a divider. When there is not enough space, buttons that don't fit will be added to an overflow menu.`}</p>
    <h2>{`Anatomy`}</h2>
    <img width="960" alt="A diagram of an action bar with a few buttons, a divider and at the end a button that opens an overflow menu." src="https://user-images.githubusercontent.com/378023/193506131-be8bead4-d1ab-4c79-8ac1-054e75bac9be.png" />
    <h2>{`Content`}</h2>
    <h3>{`Buttons`}</h3>
    <p>{`An action bar should only contain icon buttons with the `}<inlineCode parentName="p">{`invisible`}</inlineCode>{` variant (no border/background).`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/378023/193506398-6d6da18a-b70d-4cd4-b6e4-fd472a24934f.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Use only invisible icon buttons in an action bar.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/378023/193506488-44543352-f513-469e-8783-5d1cc7f44eaf.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Don't use other variants or components in an action bar.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Dividers`}</h3>
    <p>{`Dividers can be added to visually group related buttons.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/378023/193506858-6542a6ba-4bac-400d-bba9-8601fbc032ed.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Use a divider between buttons.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/378023/193506894-dc0a65a0-0f81-444a-aa8c-f3b0f74aecb5.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Don't use a divider at the beginning or end of the action bar.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Overflow menu`}</h3>
    <p>{`When the buttons don't fit in the available space, an overflow button ("kebab" icon) is added at the end of the action bar signaling that there are more actions available. Clicking on the overflow button opens a menu with the remaining actions that didn't fit.`}</p>
    <img src="https://user-images.githubusercontent.com/378023/193507064-4efe3f63-7b30-4656-8304-3dea3e3f1e03.png" alt="" width="960" />
    <h4>{`Sorting`}</h4>
    <p>{`Buttons that don't fit are added to the top of the menu. Meaning that the last button in the action bar will also be the last button when inside the menu:`}</p>
    <img src="https://user-images.githubusercontent.com/378023/188835345-0cfd3376-1658-496f-a78b-f5977aa2198c.png" alt="" width="960" />
    <h4>{`Demo`}</h4>
    <CustomVideoPlayer width="720px" loop src="https://user-images.githubusercontent.com/378023/188359460-bc88bac8-9c69-4aea-8ce0-bc427bedc3a3.mov" poster="https://user-images.githubusercontent.com/378023/188529873-eafbad89-9eeb-4342-905d-15d89d288ffd.png" mdxType="CustomVideoPlayer" />
    <Caption mdxType="Caption">Overflow button appears when not enough space and resizing the action bar updates the overflow menu.</Caption>
    <h2>{`States`}</h2>
    <h3>{`Button states`}</h3>
    <p>{`Buttons in action bars are solely used for triggering actions. Consider using a `}<a parentName="p" {...{
        "href": "https://primer.style/design/components/segmented-control"
      }}>{`segmented control`}</a>{` when a button should have a selected state.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/378023/193506579-a665b941-5b4e-4e44-9439-cfb4e7e93ef3.png" role="presentation" width="456" />
    <Caption mdxType="Caption">
      Buttons in action bars have a hover and pressed state, and a focused state when using a keyboard to navigate.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/378023/193506649-07cb8b8b-3658-477a-b7a2-f00ad9825f26.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Don't add a selected state or any other information like a notification dot or a counter.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Tooltips`}</h3>
    <p>{`When hovering over a button, a tooltip will appear that describes the action.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/378023/193506950-1702cff8-c751-4bc2-a37a-a837d1e69320.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Describe what action will be taken when clicking on the button.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/378023/193506979-07aa35d2-48f5-4b09-aa3e-c575be0e578e.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Don't use a tooltip in action bars to convey a current state.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`Action bars can have 3 different sizes:`}</p>
    <img src="https://user-images.githubusercontent.com/378023/193507132-f3ad4632-e257-4301-bd48-0669f4347ddc.png" role="presentation" width="960" />
    <ul>
      <li parentName="ul">{`Small (`}<inlineCode parentName="li">{`28px`}</inlineCode>{`)`}</li>
      <li parentName="ul">{`Medium (`}<inlineCode parentName="li">{`32px`}</inlineCode>{`) (default)`}</li>
      <li parentName="ul">{`Large (`}<inlineCode parentName="li">{`40px`}</inlineCode>{`)`}</li>
    </ul>
    <h2>{`Layout`}</h2>
    <p>{`Action bars can be used inline next to other content or also full width taking up the entire space.`}</p>
    <Box as="p" mdxType="Box">
  <img src="https://user-images.githubusercontent.com/378023/193507204-7d2e1e10-8906-49b4-9c80-10d69fce3e92.png" role="presentation" width="960" />
    </Box>
    <h3>{`Spacing`}</h3>
    <p>{`Make sure to add extra spacing around the action bar.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://user-images.githubusercontent.com/378023/193507240-00801a0a-053b-45e3-9896-9d47150f8a99.png" role="presentation" width="456" />
    <Caption mdxType="Caption">Extra padding of 8px is added when nesting an action bar in a box component.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://user-images.githubusercontent.com/378023/193507276-25dbece0-ea90-4050-8333-2a7891dee8ef.png" role="presentation" width="456" />
    <Caption mdxType="Caption">
      Avoid having the action bar touch something else. Even though the action bar buttons have no borders in their
      resting state, when hovering/pressing a button it will show a background color.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Accessibility`}</h2>
    <h3>{`Role`}</h3>
    <p>{`An action bar has an ARIA role of `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/toolbar_role"
      }}><inlineCode parentName="a">{`toolbar`}</inlineCode></a>{`.`}</p>
    <h3>{`Keyboard navigation`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Tab`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus into and out of the action bar. Note that there should only be `}<strong parentName="td">{`one tab-stop`}</strong>{` and pressing tab again should focus the next focusable element after the action bar. Also the first button is focused if the action bar is receiving focus for the first time after page load. Otherwise, the most recently focused button receives focus.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`→`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Right arrow moves focus to the `}<strong parentName="td">{`next`}</strong>{` button. If the last button has focus, focus loops back to the first button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`←`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Left arrow moves focus to the `}<strong parentName="td">{`previous`}</strong>{` button. If the first button has focus, focus moves to the last button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Home`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the `}<strong parentName="td">{`first`}</strong>{` button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`End`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Moves focus to the `}<strong parentName="td">{`last`}</strong>{` button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Enter`}</inlineCode>{` or `}<inlineCode parentName="td">{`Space`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Triggers the button `}<strong parentName="td">{`action`}</strong>{`.`}</td>
        </tr>
      </tbody>
    </table>
    {
      /* TODO: Add video */
    }
    <h3>{`Touch targets`}</h3>
    <Box as="figure" display="flex" flexDirection={['column-reverse', 'column-reverse', 'column-reverse', 'column-reverse', 'row']} m={0} mb={3} sx={{
      gap: 3
    }} mdxType="Box">
  <Text as="p" mt="0" mdxType="Text">
    Ensure action bar buttons have a large enough touch target size (44px by 44px). The buttons should respond to
    hovers, clicks, and taps anywhere in the touch target area, even if it isn't directly on the control. To avoid
    overlapping of touch targets, additional space between each button is needed (for example a 12px gap for medium
    sized buttons).
  </Text>
  <img src="https://user-images.githubusercontent.com/378023/193507314-1f1cc55d-ca4e-4832-a6de-785546e079ca.png" role="presentation" width="456" />
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      